import React from "react";
import LandingPageHomeBg from "../../../Assets/LandingPageHomeBg.png";
import Button from "../../Button/Button";

const Home = () => {
  return (
    <div
      className="relative h-screen w-full bg-cover bg-center flex flex-col items-center justify-center text-white"
      style={{
        backgroundImage: `url(${LandingPageHomeBg})`,
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>

      <div className="z-10">
        <h1 className="heading md:text-7xl">
          <div>TREE CARE,</div>
          <div>REVOLUTIONIZED.</div>
        </h1>
        <div className="mt-28 flex flex-wrap justify-center gap-4">
          <Button
            label={"ASK OUR VIRTUAL ARBORIST"}
            className="bg-white text-[#2a7d2e] font-bold py-3 px-4 md:px-9 rounded-full shadow-md hover:bg-gray-100"
          />
          <Button
            label={"GET AN ESTIMATE"}
            className="bg-[#2a7d2e] text-white font-bold py-3  px-4 md:px-9 rounded-full shadow-md hover:bg-green-700"
          />
          <Button
            label={"CONNECT WITH A PROFESSIONAL"}
            className="bg-white text-[#2a7d2e] font-bold py-3  px-4 md:px-9 rounded-full shadow-md hover:bg-gray-100"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
